import {ReactElement} from "react"

const BoatTrackingIcon = ():ReactElement => {
	return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="5.75" y="3.75" width="12.5" height="17.5" rx="1.25" stroke="#4B90C6" strokeWidth="1.5"/>
      <rect x="8.75" y="6.75" width="6.5" height="4.5" rx="1.25" stroke="#4B90C6" strokeWidth="1.5"/>
      <path d="M10 14.5H14" stroke="#4B90C6" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M8 3L8 1" stroke="#4B90C6" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  )
}

export default BoatTrackingIcon
